/**
 * @generated SignedSource<<9971ce6d88ad502a612024611b0c1084>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AIGenerationReferenceStatus = "completed" | "failed" | "pending" | "%future added value";
export type AssetFileType = "document" | "image" | "subtitle" | "unknown" | "video" | "%future added value";
export type ContentType = "assignment" | "assignment_submission" | "attachment" | "comment" | "confirmation" | "custom" | "embed" | "module" | "occurrence" | "post" | "quiz" | "survey" | "text" | "video" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AIGenerationReferenceListFragment$data = {
  readonly references: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly embeddingSource: {
          readonly asset: {
            readonly fileType: AssetFileType;
            readonly id: string;
            readonly name: string;
            readonly sizeBytes: number;
          } | null;
          readonly content: {
            readonly id: string;
            readonly name: string | null;
            readonly type: ContentType;
            readonly " $fragmentSpreads": FragmentRefs<"ContentThumbnail_ContentFragment">;
          } | null;
        } | null;
        readonly id: string;
        readonly status: AIGenerationReferenceStatus;
        readonly summary: string | null;
        readonly uploadedAsset: {
          readonly fileType: AssetFileType;
          readonly id: string;
          readonly name: string;
          readonly sizeBytes: number;
        } | null;
        readonly url: string | null;
      };
    }>;
  };
  readonly " $fragmentType": "AIGenerationReferenceListFragment";
};
export type AIGenerationReferenceListFragment$key = {
  readonly " $data"?: AIGenerationReferenceListFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AIGenerationReferenceListFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileType",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sizeBytes",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AIGenerationReferenceListFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AIGenerationReferenceNodeConnection",
      "kind": "LinkedField",
      "name": "references",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AIGenerationReferenceNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AIGenerationReference",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "summary",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EmbeddingSource",
                  "kind": "LinkedField",
                  "name": "embeddingSource",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Asset",
                      "kind": "LinkedField",
                      "name": "asset",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v1/*: any*/),
                        (v2/*: any*/),
                        (v3/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Content",
                      "kind": "LinkedField",
                      "name": "content",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "type",
                          "storageKey": null
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "ContentThumbnail_ContentFragment"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Asset",
                  "kind": "LinkedField",
                  "name": "uploadedAsset",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v3/*: any*/),
                    (v2/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AIGeneration",
  "abstractKey": null
};
})();

(node as any).hash = "6a767a6a873e074faa95c8b1f513c1ac";

export default node;
